import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'eos-template-select-exit',
  template: `
  <ng-select [items]="source | async"
    bindLabel="activityHeader"
    [placeholder]="to.placeholder"
    [formControl]="formControl" >

    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
      <div title="{{item.activityHeader}}"><span>{{ item.activityHeader }}</span></div>
      <div    title="{{item.name}}">
      <span><small>{{item.name}}</small></span></div>
      <div *ngIf="item.emailTempName && item.emailTempName.length > 0"  title="{{item.emailTempName}}">
      <span><small><strong>{{item.emailTempName}}</strong></small></span></div>
    </ng-template>
  </ng-select>
  `
})
export class TemplateSelectExitComponent extends FieldType {
  get source(): any {
    return this.to.options;
  }
}
